<template>
  <el-card>
    <template #header>
      <div class="header-class">
        <div>
          <content-header />
        </div>
        <div class="wid-class">
          <span>总充值:</span><span class="font-col">{{ recharge_total }}</span>
          <span>总余额:</span><span class="font-col">{{ wallet_money_total }}</span>
        </div>
      </div>
    </template>

    <search-form
      ref="searchForm"
      :fields="search"
    />

    <div class="div-big">
      <div style="width:48%;">
        <el-table
          :data="users"
          @row-click="rowClick"
          resource="user"
        >
            <!--          <el-table-column-->
            <!--            label="头像"-->
            <!--            align="center"-->
            <!--            width="71"-->
            <!--          >-->
            <!--            <template slot-scope="scope">-->
            <!--              <img-->
            <!--                :src="scope.row.avatar"-->
            <!--                min-width="50"-->
            <!--                height="25"-->
            <!--              >-->
            <!--            </template>-->
            <!--          </el-table-column>-->
            <!--          <el-table-column-->
            <!--            prop="truename"-->
            <!--            align="center"-->
            <!--            show-overflow-tooltip-->
            <!--            label="姓名"-->
            <!--            width="100"-->
            <!--          />-->
            <el-table-column
            prop="mobile"
            align="center"
            label="手机号码"
            width="120"
          />

          <el-table-column
            prop="areas.name"
            show-overflow-tooltip
            align="center"
            label="所属区域"
          />
          <el-table-column
            prop="deposit_money"
            align="center"
            width="80"
            label="押金(元)"
          />
          <el-table-column
            prop="recharge"
            align="center"
            width="80"
            label="充值金额(元)"
          />
          <el-table-column
            prop="wallet_money"
            align="center"
            width="80"
            label="钱包余额(元)"
          />
        </el-table>
        <div class="card-footer">
          <pagination :page="page" />
        </div>
      </div>
      <div style="width:49%;">
        <p class="border-class">钱包明细</p>
        <el-table
          :data="wallet"
          :border="false"
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            prop="operate_type"
            label="交易类型"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.operate_type_status"
                type="success"
              >{{ scope.row.operate_type }}</el-tag>
              <el-tag
                v-else
                type="danger"
              >{{ scope.row.operate_type }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="pay_type"
            label="支付方式"
            width="250"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="money"
            label="交易金额"
            align="center"
          />
          <el-table-column
            prop="status"
            label="交易状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.status"
                type="success"
              >成功</el-tag>
              <el-tag
                v-else
                type="danger"
              >失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="created_at"
            label="交易时间"
            width="180px"
            align="right"
          />
        </el-table>
        <div class="card-footer">
          <pagination
            :page="pagess"
            @current-change="walletcurrentpage"
            @size-change="walletpagesize"
            :auto-push="false"
          />
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getUsers, getUserWallet, getUserMoneySum } from "@/api/users";
import { getAreas } from "@/api/area";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          type: "el-select",
          field: "register_area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },

        {
          field: "mobile",
          label: "手机号"
        },
        {
          type: "el-select",
          field: "is_deposit",
          label: "是否缴纳押金",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: "0",
              name: "未缴纳"
            },
            {
              id: "1",
              name: "已缴纳"
            }
          ]
        }
      ],
      users: [],
      wallet: [],
      page: null,
      pagess: null,
      recharge_total: "",
      wallet_money_total: "",
      dialogVisible: false,
      nickname: "",
      status: "",
      reason: "",
      row_id: "",
      first_blood: true
    };
  },
  inject: ["reload"],
  watch: {
    $route: {
      async handler(newVal) {
        if (this.first_blood) {
          newVal.query.is_deposit = "1";
          let clientHeight = document.body.clientHeight;
          newVal.query.per_page = Math.floor((clientHeight - 360) / 52);
          this.first_blood = false;
        }
        const {
          data: { data, meta }
        } = await getUsers(newVal.query);
        this.users = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  async created() {
    const [{ data: areas }, { data: MoneySum }] = await Promise.all([
      getAreas({ all: 1 }),
      getUserMoneySum()
    ]);

    this.recharge_total = MoneySum.recharge_total;
    this.wallet_money_total = MoneySum.wallet_money_total;
    this.search[0].options.push.apply(this.search[0].options, areas);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[3].options.push.apply(
          this.search[3].options,
          merchant.data
        );
      }
    }
  },
  methods: {
    async walletcurrentpage(i) {
      this.pagess.current_page = i;
      const {
        data: { data, meta }
      } = await getUserWallet({
        user_id: this.row_id,
        page: this.pagess.current_page,
        per_page: this.pagess.page_size
      });
      this.wallet = data;
      this.pagess = meta;
    },
    async walletpagesize(i) {
      this.pagess.page_size = i;
      const {
        data: { data, meta }
      } = await getUserWallet({
        user_id: this.row_id,
        page: this.pagess.current_page,
        per_page: this.pagess.page_size
      });
      this.wallet = data;
      this.pagess = meta;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },

    async rowClick(row, column, event) {
      this.row_id = row.id;
      const {
        data: { data, meta }
      } = await getUserWallet({ user_id: row.id });
      this.wallet = data;
      this.pagess = meta;
    }
  }
};
</script>
<style lang="scss" scoped>
.label-name {
  text-align: right;
  // float: left;
  display: inline-block;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  width: 100px;
  padding: 0 12px 0 0;
  // -webkit-box-sizing: border-box;
  // box-sizing: border-box;
}
.textarea-class {
  display: inline-block;
  width: 300px;
}
.div-big {
  display: flex;
  justify-content: space-between;
}
.warning-row {
  background: rgb(172, 126, 40);
}

.success-row {
  background: #0d9e2c;
}
.border-class {
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
.header-class {
  display: flex;
  justify-content: space-between;
  .wid-class {
    width: 400px;
    text-align: right;
    span {
      padding-right: 10px;
    }
    .font-col {
      color: rgb(216, 27, 36);
    }
  }
}
</style>
